// Runtime config — populated by /config.js (rendered per-environment by the web
// container entrypoint) so ONE built image runs on stage and prod. In dev,
// web/public/config.js supplies defaults. Resolved synchronously at import time
// because sentry.ts reads it at module load, before render().
type SeatedConfig = {
  clerkPublishableKey: string
  sentryDsn: string
  sentryEnv: string
}

declare global {
  interface Window {
    __SEATED_CONFIG__?: Partial<SeatedConfig>
  }
}

const cfg = (typeof window !== 'undefined' && window.__SEATED_CONFIG__) || {}

export const config: SeatedConfig = {
  clerkPublishableKey: cfg.clerkPublishableKey || '',
  sentryDsn: cfg.sentryDsn || '',
  sentryEnv: cfg.sentryEnv || 'development',
}
